import React from "react";

export default class SegmentedControl extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    var self = this;

    /* get widths */
    var parentWindowWidth = null;
    var parentWindowHeight = null;
    var useParentWindow = $("#ffc_use_parent_window").val();

    // init parent window width and height
    if (useParentWindow) {
      parent.postMessage("windowHeight", "*");
      parent.postMessage("windowWidth", "*");
    }

    var eventMethod = window.addEventListener
      ? "addEventListener"
      : "attachEvent";
    var eventer = window[eventMethod];
    var messageEvent = eventMethod == "attachEvent" ? "onmessage" : "message";

    eventer(
      messageEvent,
      function (e) {
        if (
          e &&
          e.data &&
          typeof e.data.indexOf == "function" &&
          e.data.indexOf("windowWidth") != -1
        ) {
          parentWindowWidth = parseInt(e.data.split("windowWidth=")[1], 10);
          $(window).trigger("resize");
        } else if (
          e &&
          e.data &&
          typeof e.data.indexOf == "function" &&
          e.data.indexOf("windowHeight") != -1
        ) {
          parentWindowHeight = parseInt(e.data.split("windowHeight=")[1], 10);
          $(window).trigger("resize");
        }
      },
      false
    );

    /* setup window resize handler */

    $(window).on("load", function () {
      var $segmented_control = $(self.refs.segmented_control);
      var $container = $segmented_control.parents(".container");
      var $segmented_control_buttons = $segmented_control.find(".btn");

      $segmented_control.show();

      var seg_width = 30;
      $segmented_control_buttons.each(function () {
        seg_width += $(this).outerWidth();
      });

      $segmented_control_buttons.on("click", function () {
        var click_id = new Date().toString();
        var custom_breakpoint_width = parseInt(
          $("#ffc_resize_breakpoint").val()
        );
        if (
          parentWindowWidth &&
          custom_breakpoint_width &&
          parentWindowWidth < custom_breakpoint_width
        ) {
          if ($segmented_control.hasClass("collapsed")) {
            $segmented_control.addClass("open");
            $(window).on("click." + click_id, function () {
              $segmented_control.removeClass("open");
              $(window).off("click", +click_id);
            });
            return false;
          }
        } else {
          if ($segmented_control.hasClass("collapsed")) {
            $segmented_control.addClass("open");
            $(window).on("click." + click_id, function () {
              $segmented_control.removeClass("open");
              $(window).off("click", +click_id);
            });
            return false;
          }
        }
      });

      $(window)
        .on("resize", function () {
          var custom_breakpoint_width = parseInt(
            $("#ffc_resize_breakpoint").val()
          );

          $segmented_control.removeClass("open");

          if (custom_breakpoint_width) {
            var window_width = parentWindowWidth || $container.outerWidth();
            if (
              self.props.display == "dropdown" ||
              window_width < custom_breakpoint_width
            ) {
              $segmented_control.addClass("collapsed");
            } else {
              $segmented_control.removeClass("collapsed");
            }
          } else {
            var window_width = parentWindowWidth || $container.outerWidth();

            if (
              self.props.display == "dropdown" ||
              seg_width >= window_width ||
              window_width < 750
            ) {
              $segmented_control.addClass("collapsed");
            } else {
              $segmented_control.removeClass("collapsed");
            }
          }

          $segmented_control.css("visibility", "visible");
          $(".visible-with-segmented-control").css("visibility", "visible");
        })
        .trigger("resize");
    });
  }

  render() {
    var self = this;
    var $segmented_control = $(self.refs.segmented_control);
    var expanded = $segmented_control.hasClass("open");

    const menuId = "menu" + Math.floor(Math.random() * 10000);
    const menuButtonId = "menubutton" + Math.floor(Math.random() * 10000);

    var controls = this.props.controls.map(function (control) {
      return self.renderControlButton(control, menuId, menuButtonId);
    });

    if (this.props.all_enabled) {
      controls.unshift(
        this.renderControlButton({
          id: "All",
          path: this.props.all_path,
          name: "All",
        })
      );
    }

    var menu_items = this.props.controls
      .map(function (control) {
        return self.renderMenuItem(control);
      })
      .filter(function (x) {
        return x !== undefined;
      });

    if (menu_items.length === 0) {
      $(".course_level_display_dropdown label").hide();
      return null;
    }

    if (this.props.all_enabled) {
      menu_items.unshift(
        this.renderMenuItem({
          id: "All",
          path: this.props.all_path,
          name: "All",
        })
      );
    }

    return (
      <div
        className={
          "segmented-control " +
          (this.props.viewport || "") +
          (this.props.display == "dropdown"
            ? " collapsed mobile force-dropdown"
            : "")
        }
        ref="segmented_control"
      >
        <div className="btn-group">{controls}</div>
        <div className="dropdown">
          <ul
            className={
              "dropdown-menu " +
              (this.props.align ? this.props.align + "-aligned" : "")
            }
            role="menu"
            aria-labelledby={menuButtonId}
            id={menuId}
            aria-expanded={expanded}
          >
            {menu_items}
          </ul>
        </div>
      </div>
    );
  }

  renderControlButton(control, menuId, menuButtonId) {
    if (control.id == this.props.active_id) {
      return (
        <button
          key={"c" + control.id}
          className="btn active"
          aria-label={`${I18n.t("dropdown_menu_to_select")} ${control.name} ${
            this.props.aria_context || ""
          }${this.props.aria_context && control.id === "All" ? "s" : ""}`}
          tabIndex="0"
          id={menuButtonId}
          aria-haspopup="true"
          aria-controls={menuId}
          onClick={(e) => {
            e.preventDefault();
            window.location.href = control.path;
          }}
        >
          {control.name}
          <i className="fa fa-caret-down" />
        </button>
      );
    } else if (control.name) {
      return (
        <button
          key={"c" + control.id}
          className="btn"
          aria-label={`${I18n.t("dropdown_menu_to_select")} ${control.name} ${
            this.props.aria_context || ""
          }${this.props.aria_context && control.id === "All" ? "s" : ""}`}
          tabIndex="0"
          onClick={(e) => {
            e.preventDefault();
            window.location.href = control.path;
          }}
        >
          {control.name}
          <i className="fa fa-caret-down" />
        </button>
      );
    }
  }

  renderMenuItem(control) {
    if (control && control.name) {
      if (control.id == this.props.active_id) {
        return (
          <a
            key={"m" + control.id}
            href={control.path}
            className="active"
            aria-current="page"
            tabIndex="0"
            role="menuitem"
            aria-selected="true"
          >
            <span className="text">{control.name}</span>
            <span className="checkmark">
              <i className="fa fa-check" />
            </span>
          </a>
        );
      } else {
        return (
          <a
            key={"m" + control.id}
            href={control.path}
            tabIndex="0"
            role="menuitem"
            aria-selected="false"
          >
            <span className="text">{control.name}</span>
            <span className="checkmark">
              <i className="fa fa-check" />
            </span>
          </a>
        );
      }
    }
  }
}
